import React, { Component } from 'react';
import { List, Avatar } from 'antd';
import moment from 'moment';

/**
 * 企业浏览用户简历记录
 */
export default class UserBrowerList extends Component {
  static propTypes = {

  };

   renderItem = (item) => {
    let desc = (<div><span>查看了</span> <a >{item.nickName}</a> 的简历    </div>);
    return (<List.Item>
      <List.Item.Meta
        avatar={<Avatar src={item.logo} />}
        title={item.companyName}
        description={desc}
      />
    </List.Item>)

  }

   render() {
    const { userBrowerList } = this.props;
    return (
      <div className="home-data-tab">
        <List
          bordered={false}
          header=""
          dataSource={userBrowerList}
          renderItem={this.renderItem}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/UserBrowerList.js